(function ($) {
    class RLM_CookieToggleText {
        constructor (content) {
            this.wrapper = content;  
            this.prepareHTML();          
            this.initState();        
            this.initEvents();
        }

        prepareHTML () {
            let content = this.wrapper.find('.ctcc-left-side');
            content.html('<span class="js-cookie-toggle-content"><span class="js-cookie-toggle-content-inner">' + content.html() + '</span></span><a href="#toggle" data-text-closed="Rozwiń" data-text-open="Zwiń" class="js-cookie-toggle-content-button">Rozwiń</a>');
        }
    
        initState () {
            this.isOpen = false;
            this.UI = {
                button: this.wrapper.find('.js-cookie-toggle-content-button'),
                content: this.wrapper.find('.js-cookie-toggle-content'),
                contentInner: this.wrapper.find('.js-cookie-toggle-content-inner')
            };
        }
    
        initEvents () {
            this.UI.button.on('click', (e) => {
                e.preventDefault();
                let initialHeight = 40;

                if (this.isOpen) {
                    this.UI.content.css('height', this.UI.contentInner.outerHeight() + 'px');

                    setTimeout(() => {
                        this.UI.content.removeClass('is-open');
                        this.isOpen = false;
                        this.UI.button.text(this.UI.button.attr('data-text-closed'));
                        this.UI.content.css('height', initialHeight + 'px');
                    }, 0);

                    setTimeout(() => {
                        this.UI.content.css('height', '');
                    }, 350);
                } else {
                    this.UI.content.css('height', initialHeight + 'px');

                    setTimeout(() => {
                        this.UI.content.addClass('is-open');
                        this.UI.content.css('height', this.UI.contentInner.outerHeight() + 'px');
                        this.isOpen = true;
                        this.UI.button.text(this.UI.button.attr('data-text-open'));
                    }, 0);

                    setTimeout(() => {
                        this.UI.content.css('height', 'auto');
                    }, 350);
                }
            });
        }
    }
    
    new RLM_CookieToggleText($('#catapult-cookie-bar'));
})(jQuery);